<ng-container *transloco="let t; read: 'ACCOUNT_PROFILE_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>
  <app-tabs [items]="tabs" [currentItem]="currTab" (itemChange)="changeTab($event)"></app-tabs>
  <ion-content [scrollY]="false">
    <swiper #swiper [centeredSlides]="true" [initialSlide]="sliderOptions.initialSlide" [allowTouchMove]="sliderOptions.allowTouchMove" [spaceBetween]="10">
      <ng-container>
        <ng-template swiperSlide>
          <div class="slide">
            <ion-content class="ion-padding">
              <div class="centered-layout">
                <app-account-infos [updateHasChanges]="updateHasChanges" [setFocusToPhoneInput]="setFocusToPhoneInput"></app-account-infos>
              </div>
            </ion-content>
          </div>
        </ng-template>
      </ng-container>
      <ng-container>
        <ng-template swiperSlide>
          <div class="slide">
            <ion-content class="ion-padding">
              <div class="centered-layout">
                <div class="description mt-8">
                  <div>
                    {{ t('DESCRIPTION') }}
                  </div>
                  <div>
                    {{ t('INFOS') }}
                  </div>
                </div>
                <div class="card-compact-list mt-16">
                  <div class="card" *ngFor="let allergen of allergenItems">
                    <div class="flex items-center">
                      <ion-icon class="mr-16" [src]="allergen.svg"></ion-icon>
                      <div>{{ allergen.label }}</div>
                    </div>
                    <ion-checkbox slot="end" [formControl]="allergen.formControl"> </ion-checkbox>
                  </div>
                  <div class="description mt-16" [innerHTML]="t('MENTIONS_LEGALES')"></div>
                </div>
              </div>
            </ion-content>
          </div>
        </ng-template>
      </ng-container>
    </swiper>
  </ion-content>
</ng-container>
